import { TableBottom } from "./styled"

const onTopClass = "bottom-on-top"

// eslint-disable-next-line import/prefer-default-export
export const MoveTableBottom = (table: HTMLElement, displayOnTop: boolean) => {
    const bottom = table ? table.querySelector(TableBottom) as HTMLElement : null
    if (!bottom) return

    const hasClass = bottom.classList.contains(onTopClass)
    const bottomBounding = bottom.getBoundingClientRect()

    if (displayOnTop && !hasClass) {
        bottom.classList.add(onTopClass)
        bottom.style.width = `${bottomBounding.width}px`
        bottom.style.left = `${bottomBounding.left}px`
        bottom.style.transform = "translateY(100%)"

        setTimeout(() => {
            bottom.style.transform = "translateY(0)"
            bottom.style.transition = "transform 0.2s ease"
        }, 200)
    }

    if (!displayOnTop && hasClass) {
        bottom.style.transform = "translateY(100%)"
        bottom.style.transition = "transform 0.2s ease"

        setTimeout(() => {
            bottom.classList.remove(onTopClass)
            bottom.removeAttribute("style")
        }, 200)
    }
}
